import { Button, makeStyles } from "@material-ui/core";
import { forwardRef } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
const LinkButton = forwardRef(function LinkButton(props, ref) {
  const {
    to,
    isIcon = false,
    children,
    variant = "text",
    color = "default",
    ...rest
  } = props;
  const classes = useStyles({ isIcon, variant, color });
  return (
    <>
      <Link className={classes.linkButton} to={to} ref={ref}>
        {children}
      </Link>
    </>
  );
});

export default LinkButton;

const useStyles = makeStyles((theme) => ({
  linkButton: (props) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    padding: props.isIcon  ? theme.spacing(1.5) : theme.spacing(0.8, 2),
    borderRadius: props.isIcon ? "50%" : theme.spacing(0.5),
    backgroundColor:
      props.variant === "contained"
        ? props.color === "primary"
          ? theme.palette.primary.main
          : props.color === "secondary"
          ? theme.palette.secondary.main
          : theme.palette.grey[400]
        : "transparent",
    color: props.variant === "contained" ? "#fff" : theme.palette.text.secondary,
    transition: "background-color 0.3s ease",
    "&:hover": {
      backgroundColor:
        props.variant === "contained"
          ? props.color === "primary"
            ? theme.palette.primary.dark
            : props.color === "secondary"
            ? theme.palette.secondary.dark
            : theme.palette.grey[600]
          : theme.palette.action.hover,
    },
  }),
}));